export default function TermsOfService() {
  return (
    <div className="flex flex-col gap-2 text-sm text-gray-900 tracking-[-0.28px]">
      {" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">These 82 Office Membership Terms and Conditions (these “</span>{" "}
          <span className="font-bold leading-[1.5]">Terms</span>{" "}
          <span className="leading-[1.5]">
            ”) govern Member’s enrollment in, and use of the 82 Office membership services provided by Build Block Inc.
            (“
          </span>{" "}
          <span className="font-bold leading-[1.5]">Company</span>{" "}
          <span className="leading-[1.5]">
            ”). These Terms apply together with: (i) any separate membership agreement, membership confirmation,
            addendum, order form, or similar document issued by Company (each, a “
          </span>{" "}
          <span className="font-bold leading-[1.5]">Membership Agreement</span>{" "}
          <span className="leading-[1.5]">
            ”); and (ii) any posted house rules, community guidelines, or operational policies (collectively, “
          </span>{" "}
          <span className="font-bold leading-[1.5]">House</span> <span className="leading-[1.5]"> </span>{" "}
          <span className="font-bold leading-[1.5]">Rules</span>{" "}
          <span className="leading-[1.5]">
            ”). By enrolling in, accessing, or using the services (including via click-through acceptance), Member
            agrees to be bound by these Terms.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={1}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Definitions
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">“</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
              Member
            </span>{" "}
            <span className="leading-[1.5]">
              ” means the individual or legal entity enrolling in the membership, as identified in the applicable
              Membership Agreement.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Authorized Users
          </span>{" "}
          <span className="leading-[1.5]">
            ” means Member’s employees, contractors, and other individuals approved by Company who are permitted to
            access the Premises under Member’s membership.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Premises
          </span>{" "}
          <span className="leading-[1.5]">
            ” means the 82 Office facility located at 20 Park Rd, Burlingame, CA 94010, including any areas designated
            by Company for member use.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Dedicated Workspace
          </span>{" "}
          <span className="leading-[1.5]">
            ” means any specific desk, workstation, or private office identified in a Membership Agreement as
            exclusively assigned to Member for use during the Term.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Shared Workspace
          </span>{" "}
          <span className="leading-[1.5]">
            ” means non-assigned seating or shared areas that may be used by members on a non-exclusive basis, subject
            to availability and House Rules.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="font-bold leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Day Pass
          </span>{" "}
          <span className="font-bold leading-[1.5]">”</span>{" "}
          <span className="leading-[1.5]">
            {
              " means a single-day, non-recurring access option that, for the applicable Day Pass fee published by Company (currently $20, subject to change), entitles the holder to access designated Shared Workspace and common areas from the time of payment until 11:59 PM local time on the same calendar day, subject to availability and House Rules."
            }
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
            Virtual Address Membership
          </span>{" "}
          <span className="leading-[1.5]">{"” "}</span>{" "}
          <span className="font-normal leading-[1.5]">
            means a membership that permits lawful use of the Assigned Business Address and includes mail receiving
            services, but does not include access to or use of any workspace at the Premises.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="font-bold leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Silver Membership
          </span>{" "}
          <span className="font-bold leading-[1.5]">”</span>{" "}
          <span className="leading-[1.5]">
            {
              " means a recurring membership that includes lawful use of the Assigned Business Address, mail receiving services, and non-exclusive access to designated Shared Workspace during Company’s posted access hours."
            }
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">“</span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Assigned Business Address
          </span>{" "}
          <span className="leading-[1.5]">
            ” means the business address (including any internal identifier, mailbox, or suite notation) provided by
            Company for Member’s use, as described in the Membership Agreement.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={2}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Scope; Nature of Relationship; No Lease
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
        {" "}
        <p className="leading-[1.5]">
          Company provides flexible workspace and related services, which may include (depending on the applicable
          membership type or Day Pass offering and availability):
        </p>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Business address use and mail receiving (subject to USPS/CMRA requirements and Company policies)
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">(b) Access to Shared Workspace and/or Dedicated Workspace</p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">(c) Access to common areas, lounges, kitchens, and shared amenities</p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">(d) Use of shared facilities including meeting rooms and printers</p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p className="leading-[1.5]">
          Company may modify, suspend, or discontinue specific services, amenities, or access procedures in whole or in
          part for operational, safety, legal, or maintenance reasons. Membership types, tiers, included allowances, and
          other benefits may change from time to time. The specific benefits and services currently included with a
          given membership or Day Pass are as described in the applicable Membership Agreement or Company’s then-current
          posted policies.
        </p>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p className="leading-[1.5]">
          The parties intend the Membership Agreement, and these Terms, to be an office services and workspace license
          arrangement. Company retains possession and control of the Premises at all times. No landlord-tenant
          relationship, tenancy, leasehold estate, or other real property interest is created in Member’s favor.
        </p>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={3}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Access; Use of Workspace; House Rules
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Member’s access to the Premises is limited to Authorized Users and is subject to Company’s published
            access hours, security procedures, and House Rules.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Shared Workspace is non-assigned and may be used on a first-come, first-served basis. Company may limit
            prolonged occupation, unattended items, and the amount of space used by any one Member.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) If Member is assigned a Dedicated Workspace, Member may use the Dedicated Workspace exclusively as
            between members during access hours, subject to Company’s rights of entry for safety, maintenance,
            inspections, or to address emergencies.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (d) Visitors are permitted only in accordance with House Rules. Member is responsible for visitors’ conduct.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (e) Commercial filming, events, or extended accompaniment of external visitors require Company’s prior
            written approval
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (f) Company may temporarily limit or interrupt access or services due to inspections, maintenance, repairs,
            emergencies, system failures, or other operational issues. Company will use reasonable efforts to restore
            impacted services promptly.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={4}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Business Address; Mail Services
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Subject to the Membership Agreement and these Terms, Member may use the Assigned Business Address solely
            for lawful business purposes (e.g., entity formation filings, licensing, banking and insurance). Member is
            solely responsible for all legal, administrative, tax, immigration, and regulatory matters relating to
            Member’s business operations and address use.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Internal identifiers (e.g., internal unit numbers, mailbox numbers, or “#” designations) are for
            Company’s internal operations and mail management only and do not create a separate legal suite, tenancy, or
            subtenancy.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(c) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              USPS/CMRA Compliance
            </span>{" "}
            <span className="leading-[1.5]">
              . If mail receiving is provided, Member must complete all documentation required by Company policy and
              USPS rules (including PS Form 1583, as applicable) and must keep authorized recipients and identification
              information current.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(d) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Member will not
            </span>{" "}
            <span className="leading-[1.5]">
              : (i) use the address for unlawful or deceptive purposes; (ii) transfer, sublicense, or permit third
              parties to use the address without Company’s prior written consent; or (iii) represent to any third party
              that Member has a lease, tenancy, or real property interest in the Premises.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (e) Company does not inspect or open mail. Company is not responsible for carrier delays, misdelivery, loss,
            theft, or damage to mail or packages except to the extent caused by Company’s gross negligence or willful
            misconduct.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(f) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Mail Retention
            </span>{" "}
            <span className="leading-[1.5]">
              . Mail and packages may be accepted only within size and storage limitations. Items exceeding retention
              periods or storage capacity may be returned to sender or discarded in Company’s reasonable discretion.
              Mail retention periods, if any, are as specified in the applicable Membership Agreement or Company’s
              then-current posted policies and may vary by membership type.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (g) Upon termination or expiration, Member must immediately cease using the Assigned Business Address and
            promptly update all external registrations reflecting the address. Company has no obligation to accept,
            store, or forward mail received after termination
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={5}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Meeting Rooms
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Meeting rooms operate on a reservation basis and are subject to availability and House Rules.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Complimentary meeting room usage, if any, is as specified in the applicable Membership Agreement or
            Company’s then-current posted policies and may vary by membership type.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">(c) Additional usage is charged at the rates then published by Company.</p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (d) Repeated no-shows, late cancellations, or misuse may result in restrictions or fees.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={6}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Printers and Shared Equipment
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Complimentary printing, if any, is as specified in the applicable Membership Agreement or Company’s
            then-current posted policies and may vary by membership type.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Additional printing and related fees are charged at the rates then published by Company.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) Excessive or abusive usage may be limited pursuant to a fair use policy.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={7}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Signage
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Signage may be available only to eligible members as determined by Company, subject to the applicable
            Membership Agreement, posted policies, space capacity and Company approval.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Signage is provided on a first-come, first-served basis and must comply with Company specifications.
            Signage must be removed promptly upon membership termination.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={8}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Restrictions; Prohibited Conduct; Suspension
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Membership may not be assigned, transferred, resold, or shared except as expressly permitted in the
            Membership Agreement and House Rules.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Member and Authorized Users must comply with all applicable laws and must not: (i) misuse the address or
            facilities; (ii) interfere with operations or other members; (iii) damage property; (iv) engage in
            harassment, discrimination, or unsafe conduct; or (v) bring weapons, explosives, or other dangerous items
            onto the Premises.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) Company may restrict access, suspend services, or terminate membership when reasonably necessary to
            maintain safety, security, legal compliance, or community standards. Immediate suspension or termination may
            occur without prior notice for: illegal conduct; suspected address misuse; facility damage or security
            risks; non-payment or chargebacks; or unauthorized sharing of access credentials.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={9}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Fees; Billing; Payment
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Membership fees are charged on an automatic recurring, prepaid basis. Member authorizes Company (and its
            payment processors) to charge the payment method on file for all amounts due, including recurring fees,
            add-on services, and applicable taxes. Day Passes and other one-time offerings are charged as single,
            non-recurring, prepaid transactions rather than on a recurring basis.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Member must maintain a valid payment method. Payment failure may result in a request to update payment
            information and may trigger suspension or termination. Company may assess reasonable administrative fees for
            chargebacks or returned payments to the extent permitted by law.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) All fees are exclusive of applicable sales, use, or other taxes, which may be charged where required.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={10}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Membership Changes
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Member may request membership changes in accordance with Company procedures and subject to availability.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Upgrades generally take effect upon payment of prorated differences. Downgrades may be restricted during
            the then-current term unless Company approves otherwise in writing.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) Promotions or discounts may be subject to additional terms and may not transfer upon changes.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={11}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Termination; Effect of Termination
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Either party may terminate for material breach by the other party after written notice and a reasonable
            opportunity to cure, except where immediate termination is permitted under these Terms.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Member may request cancellation at any time through Company procedures; however, cancellation timing and
            effectiveness are governed by the notice and billing rules in the Membership Agreement and these Terms.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) Upon termination, Member’s access to the Premises, address usage rights, and services may immediately
            cease. Rights and obligations accrued prior to termination survive as provided in these Terms.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={12}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Refund Policy
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) Monthly memberships are non-refundable except as required by applicable law.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Annual memberships terminated early may be eligible for a partial refund calculated by Company using
            reasonable standards, which may include: (i) actual usage calculated at the then-current monthly retail
            rate; (ii) exclusion of promotions; (iii) a non-refundable portion equivalent to three (3) months; and (iv)
            partial months counted as full months. No refund will be issued if the calculated refund amount is zero or
            negative.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={13}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Confidentiality
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">
              (a) Each party may receive non-public information from the other in connection with the membership (“
            </span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-semibold leading-[1.5] underline">
              Confidential Information
            </span>{" "}
            <span className="leading-[1.5]">
              ”). Each party will use the other’s Confidential Information solely for purposes of performing under the
              Membership Agreement and will not disclose it to third parties except to its employees, contractors, and
              professional advisors who have a need to know and are bound by confidentiality obligations.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Confidentiality obligations survive for one (1) year after termination, except for trade secrets, which
            remain protected for so long as they remain trade secrets under applicable law.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={14}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Disclaimer; Limitation of Liability
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">
              (a) Except as expressly stated in the Membership Agreement or these Terms, the services and Premises are
              provided “
            </span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-semibold leading-[1.5] underline">
              as is
            </span>{" "}
            <span className="leading-[1.5]">” and “</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-semibold leading-[1.5] underline">
              as available
            </span>{" "}
            <span className="leading-[1.5]">
              ,” without warranties of any kind, whether express, implied, or statutory.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) To the maximum extent permitted by law, Company is not liable for indirect, incidental, special,
            consequential, or punitive damages, or for lost profits, lost revenue, or business interruption.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) Company’s total liability arising out of or relating to the membership will not exceed the fees paid by
            Member to Company in the three (3) months preceding the event giving rise to the claim.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={15}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Indemnification
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex text-sm text-gray-900 tracking-[-0.28px] w-full">
        {" "}
        <p>
          {" "}
          <span className="leading-[1.5]">
            Member will defend, indemnify, and hold harmless Company and its officers, directors, employees, agents,
            affiliates, and property managers (collectively, the “
          </span>{" "}
          <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid font-bold leading-[1.5] underline">
            Company Parties
          </span>{" "}
          <span className="leading-[1.5]">
            ”) from and against any claims, demands, damages, liabilities, penalties, fines, costs, and expenses
            (including reasonable attorneys’ fees) arising out of or relating to: (i) Member’s business activities; (ii)
            Member’s or Authorized Users’ use of the Premises, services, or Assigned Business Address; or (iii) Member’s
            breach of the Membership Agreement, these Terms, or applicable law, except to the extent caused by Company’s
            gross negligence or willful misconduct.
          </span>{" "}
        </p>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={16}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Governing Law; Venue; Class Action Waiver
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (a) These Terms are governed by the laws of the State of California, without regard to conflict-of-laws
            rules.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (b) Any dispute arising out of or relating to the membership will be brought exclusively in the state courts
            located in San Mateo County, California, or the U.S. District Court for the Northern District of California,
            and the parties consent to personal jurisdiction in those courts.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p className="leading-[1.5]">
            (c) To the extent permitted by law, Member agrees to resolve disputes on an individual basis and waives the
            right to participate in any class, collective, or representative action.
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex w-full">
        {" "}
        <div className="flex font-bold text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <ol className="list-decimal" start={17}>
            {" "}
            <li className="ms-5">
              {" "}
              <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
                Miscellaneous
              </span>{" "}
            </li>{" "}
          </ol>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(a) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Entire Agreement
            </span>{" "}
            <span className="leading-[1.5]">
              . The Membership Agreement and these Terms (together with House Rules) constitute the entire agreement
              between the parties regarding the membership and supersede all prior or contemporaneous understandings on
              the subject.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(b) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Assignment
            </span>{" "}
            <span className="leading-[1.5]">
              . Member may not assign or transfer the membership or these Terms without Company’s prior written consent.
              Company may assign its rights and obligations in connection with a merger, acquisition, reorganization, or
              sale of assets.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(c) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Notices
            </span>{" "}
            <span className="leading-[1.5]">
              . Notices to Company must be sent to 82office@buildblock.io (or such other address as Company may
              designate by notice). Notices to Member may be sent to the email address on file or as otherwise specified
              in the Membership Agreement.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(d) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Severability; Waiver
            </span>{" "}
            <span className="leading-[1.5]">
              . If any provision is held unenforceable, the remaining provisions remain in effect. No waiver is
              effective unless in writing, and no waiver of any breach constitutes a waiver of any subsequent breach.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(e) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Force Majeure
            </span>{" "}
            <span className="leading-[1.5]">
              . Company is not responsible for failure or delay in performance due to causes beyond Company’s reasonable
              control (e.g., utilities, internet outages, building system failures, acts of government, labor disputes,
              or natural disasters).
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
      <div className="flex px-6 w-full">
        {" "}
        <div className="flex text-sm text-gray-900 tracking-[-0.28px]">
          {" "}
          <p>
            {" "}
            <span className="leading-[1.5]">{"(f) "}</span>{" "}
            <span className="[text-decoration-skip-ink:none] [text-underline-position:from-font] decoration-from-font decoration-solid leading-[1.5] underline">
              Electronic Acceptance
            </span>{" "}
            <span className="leading-[1.5]">
              . Electronic acceptance has the same legal effect as a handwritten signature.
            </span>{" "}
          </p>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
}
